import { render } from "./TYargu.vue?vue&type=template&id=e8e04772&scoped=true"
import script from "./TYargu.vue?vue&type=script&lang=js"
export * from "./TYargu.vue?vue&type=script&lang=js"

import "./TYargu.vue?vue&type=style&index=0&id=e8e04772&lang=scss&scoped=true"
import "./TYargu.vue?vue&type=style&index=1&id=e8e04772&lang=css"

import exportComponent from "D:\\workCode\\web-backEnd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e8e04772"]])

export default __exports__